import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mask-content"
};
import { computed } from 'vue';
import gsap from 'gsap';
export default {
  __name: 'MaskerLayer',
  props: {
    position: {
      type: Object,
      default: () => ({
        vertical: 'center',
        horizontal: 'center'
      })
    },
    duration: {
      type: Number,
      default: 1000
    }
  },
  emits: ['close'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const maskStyle = computed(() => ({
      transition: `opacity ${props.duration}ms ease`
    }));

    const contentBeforeEnter = el => {
      el.style.opacity = 0;
      el.style.transform = 'translate(-50%, -50%) scale(0.9)';
    };

    const contentEnter = (el, done) => {
      gsap.to(el, {
        opacity: 1,
        scale: 1,
        duration: props.duration / 1000,
        onComplete: done
      });
    };

    const contentLeave = (el, done) => {
      gsap.to(el, {
        opacity: 0,
        scale: 0.9,
        duration: props.duration / 1000,
        onComplete: done
      });
    };

    const handleClickOutside = () => {
      emits('close');
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "full-screen-mask",
        style: _normalizeStyle(maskStyle.value),
        onClick: _withModifiers(handleClickOutside, ["self"])
      }, [_createVNode(_Transition, {
        name: "content-animate",
        onBeforeEnter: contentBeforeEnter,
        onEnter: contentEnter,
        onLeave: contentLeave,
        css: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])]),
        _: 3
      })], 4);
    };
  }

};